import * as mobx from 'mobx';
import { connectionIdValueTypeGuard } from './types-guard';

type EntityId = number;

const _value = 'value';
export const _props = Symbol('immutable props');

export abstract class ConnectionEntity<T> {
    abstract getId(): EntityId;
    abstract toDTO(): T;

    private readonly [_props]?: Partial<T>;

    public getProps(): Partial<T> {
        return this[_props];
    }

    protected constructor(private readonly _key: string, props: Partial<T>) {
        this[_key] = {};
        this[_props] = props;
    }

    @mobx.action
    public assignConnection(id: number): void {
        connectionIdValueTypeGuard(id);
        Reflect.set(this[this._key], _value, id);
    }

    @mobx.action
    public setPropsValue(typeKey: string, typeValue: string): void {
        Reflect.set(this[_props], typeKey, typeValue);
    }

    @mobx.action
    public removePropsValue(typeKey: string): void {
        if (typeKey in this.getProps()) Reflect.deleteProperty(this[_props], typeKey);
    }

    public hasPropsValue(typeKey: string): boolean {
        return typeKey in this.getProps();
    }

    @mobx.action
    public removeAssignedConnection(): void {
        if (this.hasAssignedConnection()) Reflect.deleteProperty(this[this._key], _value);
    }
    @mobx.action
    public invalidateAssignedConnectionById(id: number): void {
        if (Reflect.has(this[this._key], _value) && Reflect.get(this[this._key], _value) === id) {
            Reflect.deleteProperty(this[this._key], _value);
        }
    }
    public getAssignedConnection(): number {
        return Reflect.get(this[this._key], _value);
    }

    public hasAssignedConnection(): boolean {
        return Reflect.has(this[this._key], _value);
    }
}

